import { render, staticRenderFns } from "./CPSInvestmentPromotion.vue?vue&type=template&id=fea59994&scoped=true"
import script from "./CPSInvestmentPromotion.vue?vue&type=script&lang=ts"
export * from "./CPSInvestmentPromotion.vue?vue&type=script&lang=ts"
import style0 from "./CPSInvestmentPromotion.vue?vue&type=style&index=0&id=fea59994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea59994",
  null
  
)

export default component.exports